import { render, staticRenderFns } from "./v-dropdown.vue?vue&type=template&id=d5f4ed34&"
import script from "./v-dropdown.vue?vue&type=script&lang=js&"
export * from "./v-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports